import { FC } from "react";

import __ from "web/Layout/Translations";

import Switch from "web/Components/Common/Switch";

import { CodeItemStatusCode } from "web/hooks/useCodeItemStatus/useCodeItemStatus";

import Progress from "../../Progress";
import classes from "./codeItemHeader.scss";

interface ICodeItemHeader {
  className?: string;
  onChange: (val: boolean) => void;
  switchable?: boolean;
  label: string;
  statusCode: CodeItemStatusCode;
  active: boolean;
  noBackground?: boolean;
  name: string;
}

const CodeItemHeader: FC<ICodeItemHeader> = ({
  className,
  onChange,
  switchable = false,
  label,
  statusCode,
  active,
  noBackground = false,
  name,
}) => {
  const classNameRoot = className || classes.root;

  return (
    <header className={classNameRoot}>
      <span className={classes.container}>
        {switchable ? (
          <div
            className={`switch ${switchable && "active"} ${classes.content}`}
          >
            <Switch
              classes={{
                ...classes,
                background: noBackground
                  ? classes.noBackground
                  : classes.background,
              }}
              active={active}
              size={21}
              label={
                <span className="statusText" data-t1="status_text_4">
                  {__(label)}
                </span>
              }
              onChange={onChange}
              disabled={!switchable}
              ariaLabel={
                active
                  ? `${__("Oznacz kod jako wykorzystany")} - ${name}`
                  : `${__("Oznacz kod jako niewykorzystany")} - ${name}`
              }
            />
          </div>
        ) : (
          <div className={classes.content}>
            <div className={classes.label}>
              {statusCode === CodeItemStatusCode.WAITING ||
              statusCode === CodeItemStatusCode.WAITING_FOR_PAYMENT ? (
                <Progress />
              ) : null}
              <span className="statusText" data-t1="status_text_4">
                {__(label)}
              </span>
            </div>
          </div>
        )}
      </span>
    </header>
  );
};

export default CodeItemHeader;
